import {config} from './config/slider'

// For desktop
const $module = $('.btd-module-kts');
let ktsVideoPlayer = {};

$module.each(function (index) {
    const $kts = $(this);
    $kts.find('.kts-video__slider-desktop').slick({
        ...config,
        variableWidth: false,
    });

    // Render the first slide video
    const firstSlide = $('.slick-slide.slick-active a.kts-card ', $kts).first();
    const moduleid = $kts.data('moduleid');
    renderPreview(firstSlide, moduleid);
    ktsVideoPlayer[moduleid] = createKtsPlayer(`kts-video__preview-${moduleid}`, firstSlide.data('id'));

    // For mobile version
    const videoPlayersMobile = [];
    const $KtsMobileSlider = $kts.find('.kts-video__slider-mobile');
    $KtsMobileSlider.find('.kts-video').each(function () {
        const previewContainer = $(this).find('.kts-video__preview-mobile').first();
        const videoId = previewContainer.attr('data-id');
        const previewContainerId = `kts-video__preview-mobile-${moduleid}-${videoId}-${previewContainer.attr('data-index')}`;
        const mobilePlayer = createKtsPlayer(previewContainerId, videoId);
        videoPlayersMobile.push(mobilePlayer);
    });

    $KtsMobileSlider.slick({
        ...config,
        variableWidth: false,
        slidesToShow: 1,
        arrows: false,
        dots: true,
        responsive: [],
    });
    $KtsMobileSlider.on('beforeChange', (e, _, currentSlide) =>{
        videoPlayersMobile[currentSlide].stopVideo();
    });
});

$('.kts-card', $module).on('click', function () {
    const $card = $(this);
    const moduleId =  $card.parents('.btd-module-kts').data('moduleid');
    const videoId =  $card.data('id');
    renderPreview($card, moduleId);
    const $sliderContainer = $(`.btd-module-kts-${moduleId}`).find('.kts-slider');
    const videoPreviewId = `kts-video__preview-${moduleId}`;
    $sliderContainer.find('.kts-card').removeClass('active-video');
    $card.addClass('active-video');
    const slideNumber = $card.closest('.slick-slide').attr('data-slick-index');
    $sliderContainer.find('.kts-video__slider-desktop').slick('slickGoTo', slideNumber);

    // stop if any video is playing
    $.each(ktsVideoPlayer, function(key, videoPlayer){
        videoPlayer.stopVideo();
    });

    if (ktsVideoPlayer[moduleId]) {
        try {
            ktsVideoPlayer[moduleId].reloadPlayer({
                id: videoPreviewId,
                configUrl: `${currentEnvironment.spottEndpoint}/content/${videoId}/player-setting?showTitle=false`,
                allowDVR: true
            });
        } catch (error) {}
    } else {
        ktsVideoPlayer[moduleId] = createKtsPlayer(videoPreviewId, videoId);
    }
    return false;
})


function renderPreview($el, moduleid) {
    $el.addClass('active-video');
    const $currentModule = $(`.btd-module-kts-${moduleid}`);
    const $contentButton = $currentModule.find('.content-button');
    const buttonText = $el.data('button-text');

    $currentModule.find('.kts-video__title').text($el.data('title'));
    $currentModule.find('.kts-video__description').text($el.data('description'));
    $contentButton.hide();
    if ( $el.data('read-more-button') === 1 && buttonText.length > 0) {
        $contentButton.show();
        $contentButton.find('.link-btn').attr('href', $el.data('link')).text(buttonText);
    }

    return $el.data('id');
}

function createKtsPlayer(id, videoId) {
    return new avvpl.setupPlayer({
        id: id,
        configUrl: `${currentEnvironment.spottEndpoint}/content/${videoId}/player-setting?autoplay=false&showTitle=false`,
        allowDVR: true
    });
}

